import { HttpClient } from '@angular/common/http';
import { inject, Injectable, resource, ResourceRef } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import Stripe from 'stripe';

@Injectable({
    providedIn: 'root'
})
export class SubscriptionService {
    private readonly _http = inject(HttpClient);

    getCustomerSession(): ResourceRef<Stripe.CustomerSession> {
        return resource({
            loader: ({ request }) => firstValueFrom(this._http.post<Stripe.CustomerSession>('/api/payments/customer-session', request))
        });
    }

    async openBillingPortal() {
        const { url } = await firstValueFrom(this._http.post<{ url: string; }>('/api/payments/billing-portal-session', {}));

        window.open(url, '_blank');
    }

    async endTrial() {
        await firstValueFrom(this._http.post('/api/payments/subscription/end-trial', {}));
    }
}
